module.exports = __webpack_public_path__ + "img/mobile-camera-frame.eb464780.png";